import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiArrowRight } from 'react-icons/fi';
import { zodiacSigns } from '../../data/zodiacSigns';
import { useTranslation } from '../../hooks/useTranslation';
import './HoroscopePreview.css';

const HoroscopePreview = () => {
  const { t } = useTranslation();
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.05 }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: { duration: 0.4 }
    }
  };

  return (
    <section className="horoscope-preview section">
      <div className="container">
        <div className="section-title">
          <h2>{t('horoscopePreview.title')}</h2>
          <p>{t('horoscopePreview.subtitle')}</p>
        </div>

        <motion.div
          className="zodiac-grid"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-50px" }}
        >
          {zodiacSigns.map((sign) => (
            <motion.div key={sign.id} variants={itemVariants}>
              <Link
                to={`/horoscope/${sign.name.toLowerCase()}`}
                className="zodiac-card"
                style={{ '--zodiac-color': sign.color }}
              >
                <div className="zodiac-symbol">{sign.symbol}</div>
                <h4>{sign.name} <span className="tamil-name">({sign.tamilNameEn})</span></h4>
                <span className="zodiac-dates">{sign.dates}</span>
              </Link>
            </motion.div>
          ))}
        </motion.div>

        <div className="horoscope-cta">
          <Link to="/horoscope" className="btn btn-secondary">
            {t('horoscopePreview.viewAll')} <FiArrowRight />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default HoroscopePreview;
